/**
 * Shared fallback resolver for admin-entered content translated as `{field}` / `{field}_en` /
 * `{field}_cn` on an API response (redeem-point campaigns, appointment density descriptions -
 * LMP-6907). Chain matches i18n.ts's own fallbackLng (`cn -> [en, th]`, `default -> [th]`) and the
 * aura-backend TranslatableMixin.translate() this data comes from.
 *
 * Takes explicit th/en/cn values rather than an object + field name so it stays trivially typed
 * (no dynamic key indexing) and reusable across shapes that don't share an interface.
 */
export function pickTranslated(
  th: string | null | undefined,
  en: string | null | undefined,
  cn: string | null | undefined,
  lang = 'th',
): string {
  const thValue = th ?? ''
  const enValue = en ?? thValue
  const cnValue = cn ?? enValue

  if (lang === 'cn') return cnValue
  if (lang === 'en') return enValue
  return thValue
}
